module.exports = __webpack_public_path__ + "img/section10_it.f2eddd5.png";